<template>
  <span>{{number}}</span>
</template>

<script>
export default {
  name: 'constantNum',
  props:{
    setNumber:{
        default: 0,
        type: Number
    },
    duration:{
        default: 1,
        type: Number
    },
  },
  watch:{
    setNumber:{
        handler(aimNum){
            let timer = setInterval(()=>{
                if(this.number < aimNum){
                    this.number = this.setNum(this.number,aimNum)
                }else{
                    clearTimeout(timer)
                }
            },this.getSpeed(aimNum))
        },
        immediate: true
    }
  },
  data () {
    return {
        number: 0
    }
  },
  methods: {
    getSpeed(aimNum){
        let currentNum = 0
        let time = 0
        for(let i=0; currentNum<aimNum; i++){
            currentNum = this.setNum(currentNum,aimNum)
            time++
        }
        return this.duration/time
    },
    setNum(currentNum,aimNum){
        if(aimNum - currentNum > 3000){
            currentNum += 33
        }else if(aimNum - currentNum > 1000){
            currentNum += 23
        }else if(aimNum - currentNum > 500){
            currentNum += 7
        }else if(aimNum - currentNum > 100){
            currentNum += 3
        }else if(aimNum - currentNum > 50){
            currentNum += 2
        }else if(aimNum - currentNum > 0){
            currentNum += 1
        }
        return currentNum
    }
  },
}
</script> 

<style lang='less' scoped>

</style>
